import React, { FunctionComponent } from "react";
import { NumberFormatProps, NumberFormatValues } from "react-number-format";
import { NumberInput } from "components/inputs/NumberInput";
import { useField } from "formik";

export interface Props extends NumberFormatProps {
  name: string;
}

export const FormikNumberField: FunctionComponent<Props> = ({ name, ...props }) => {
  const [{ value, onBlur }, , { setValue }] = useField(name);

  const handleChange = (values: NumberFormatValues) => {
    return setValue(values.floatValue);
  };

  return (
    <NumberInput
      id={name}
      name={name}
      value={(value as number) || ""}
      onValueChange={handleChange}
      onBlur={onBlur}
      {...props}
    />
  );
};

FormikNumberField.displayName = "FormikNumberField";
